<div id="container">
    <div id="date">
        <mtx-date [ngStyle]="inputStyles" [inputDate]="inputDate" [includeDay]="includeDay" [includeMonth]="includeMonth"></mtx-date>
    </div>
    &nbsp;
    <div id="time">
        <mtx-time [ngStyle]="inputStyles" [inputDate]="inputDate"></mtx-time>
    </div>
</div>
